export default Object.freeze({
  TITLE: '게시글 등록',
  TITLE_UPDATE: '게시글 수정',
  TH_ONE: '제목',
  TH_TWO: '공개여부',
  TH_TWO_TRUE: '공개',
  TH_TWO_FALSE: '비공개',
  TH_THREE: '쇼핑몰/게시판',
  TH_FOUR: '게시판 카테고리',
  TH_TAG: '태그',
  TH_FIVE: '대표이미지',
  TH_FIVE_SPAN: '대표 이미지를 추가해 주세요.',
  TH_FIVE_SPAN_TWO: '이미지 찾기',
  TH_NOTICE: '공지',
  TH_FILE: '첨부파일 (최대 {number}개)',
  BTN_ADD_FILE: '파일찾기',
  BTN_SAVE: '게시글 등록',
  BTN_CANCEL: '취소',
  ALERT_BOARD_DISABLED: '쇼핑몰에 등록된 게시판이 없습니다. 게시판을 먼저 등록해 주세요.',
  ALERT_BOARD_NO_SELECT: '게시판을 선택해주세요.',
  ALERT_CATEGORY_DISABLED: '게시판 카테고리를 선택해주세요.',
  ALERT_ARTICLE_TITLE: '제목을 입력해 주세요.',
  ALERT_SUMMERNOTE_EMPTY: '내용을 입력해 주시기 바랍니다.',
  ALERT_SUMMERNOTE_LONG: '본문의 길이가 너무 깁니다.',
  CONFIRM_SAVE: '게시글을 등록하시겠습니까?',
  ALERT_SUCCESS: '게시글이 등록되었습니다.',
  CONFIRM_CANCEL: '취소하시겠습니까? 수정하신 내용은 저장되지 않습니다.',
  ALERT_ERROR: '업로드된 파일이 없습니다.',
  CONFIRM_DELETE: '첨부파일을 삭제하시겠습니까?',
  ALERT_FILE_LENGTH: '첨부파일은 최대 10개만 등록 가능합니다.',
  PARENT_BOARD: '상위 게시물',
  AUTHOR: '작성자',
  AUTHOR_DATE: '작성일시',
  BOARD_NO: '게시글번호',
  SEARCH_TIME: '조회수',
  REPLY_COUNT: '답글수',
  RECOMMEND_COUNT: '추천수',
  FIX_ORDER: '순서고정',
  SELECT_BOARD: '게시판 선택',
  SELECT_CATEGORY: '게시판 카테고리 선택',
  LAST_WRITE: '최종수정자',
  LAST_DATE: '최종수정일시',
  MEMBER_INFO: '회원정보',
});
